export default __webpack_public_path__ + "static/media/notification-8.81714bfa.mp3";